<template>
  <div
    class="col-12 col-xl-8 col-xxl-7 mr-auto mx-auto"
    style="
      border: 1px solid #cccccc;
      border-radius: 8px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
      font-family: IRANSansX-Regular;
      background: #fff;
    ">
    <div
      class="w-100 text-right p-4 pb-2"
      dir="rtl">
      <h4>
        <img
          width="28"
          src="data:image/svg+xml;utf8;base64,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" >
        تنظیمات
      </h4>
    </div>
    <div class="container">
      <div class="row">
        <div
          class="col-12 mr-auto mx-auto"
          dir="rtl">
          <div class="card p-2 m-2">
            <div class="card-body">
              <h5 class="text-muted">
                انتخاب شهر پیش‌فرض
              </h5>
              <autocomplete
                :search="search"
                :get-result-value="getResultValue"
                aria-label="جستجوی موقعیت جغرافیایی"
                placeholder="جستجوی شهر"
                @submit="handleSubmit"/>
              <div
                class="w-100 p-2 text-center mt-2"
                dir="rtl">
                <em class="bg-light text-dark rounded p-2 small ">{{ selectedLocation }}</em>
              </div>
            </div>
            <div class="card-body border-top">
              <h5 class="text-muted">
                آنالیز چارت
                <button
                  class="btn btn-link"
                  data-bs-toggle="modal"
                  data-bs-target="#analysisBoxSettings">
                  <svg
                    id="info"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24">
                    <path
                      fill="#0d6efd"
                      d="M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-22C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/>
                    <path
                      fill="#0d6efd"
                      d="M11 18c-.4 0-.7-.2-1-.5-.5-.7-.1-1.7 1-4.4.2-.4.4-.9.6-1.3-.4.3-1 .3-1.4-.1-.4-.4-.4-1 0-1.4.2-.1 1.4-1.3 2.8-1.3.4 0 .7.2 1 .5.5.7.1 1.7-1 4.4-.2.4-.4.9-.6 1.3.4-.3 1-.3 1.4.1.4.4.4 1 0 1.4-.2.1-1.4 1.3-2.8 1.3z"/>
                    <circle
                      fill="#0d6efd"
                      cx="13.5"
                      cy="6.5"
                      r="1.5"/>
                    <path
                      fill="#0d6efd"
                      d="M13.5 8.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"/>
                  </svg>
                </button>
              </h5>
              <div class="pt-4">
                <div class="row">
                <div class="col-6 col-sm-3">
                  نمایش جعبه آنالیز
                </div>
                <div class="col-6 col-sm-3 text-start text-sm-end mb-4">
                  <label class="switch">
                    <input
                      v-model="show_analysis"
                      type="checkbox">
                    <span class="slider"/>
                  </label>
                </div>
                <div class="col-6 col-sm-3">
                  شناسایی یوگاها
                </div>
                <div class="col-6 col-sm-3 text-start text-sm-end">
                  <label class="switch">
                    <input
                      v-model="show_yogas"
                      type="checkbox">
                    <span class="slider"/>
                  </label>
                </div>
              </div>
              </div>
            </div>
            <div
              class=" text-center"
              dir="ltr">
              <div class="w-100 p-2 pt-3 pb-3">
                <!-- <button :class="`btn btn-success ${this.enable_submit ? '' : 'disabled'}`" -->
                <button
                  class="btn btn-success"
                  @click="updateSettings">ذخیره</button>
              </div>
            </div>
          </div>
          <div
            class="p-2 mb-3"
            style="font-size: 12px">

            <div
              class="w-100  text-center"
              dir="ltr"
              style="font-style: italic; color: #121212;">

              <button
                style="font-size: 12px"
                class="btn btn-light bg-white border-0"
                data-bs-toggle="modal"
                data-bs-target="#aboutHoraPro">
                <strong>Hora Pro: 1.0.5</strong>
              </button>

            </div>
          </div>
          <div
            v-if="error"
            class="p-2 mt-4 text-center mr-auto mx-auto mb-2 text-danger"
            style="color: #dc3545; border: 1px solid #dc3545; border-radius: 8px; width: fit-content;">
            بروزرسانی با مشکل روبرو شده است لطفا دوباره امتحان کنید.
          </div>
          <div
            v-if="success"
            class="p-2 mt-4 text-center mr-auto mx-auto mb-2 text-success"
            style="color: #339966; border: 1px solid #339966; border-radius: 8px; width: fit-content;">
            بروزرسانی با موفقیت انجام شد.
          </div>
        </div>
      </div>
    </div>
    <loading :is-loading="isLoading" />
    <div
      id="analysisBoxSettings"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="analysisBoxSettings"
      aria-hidden="true"
      style="background: rgba(0, 0, 0, 0.2)">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div
            class="modal-header"
            dir="rtl">
            <h1
              id="exampleModalLabel"
              class="modal-title fs-5">آنالیز چارت</h1>
            <button
              type="button"
              class="btn-close me-auto ms-0"
              data-bs-dismiss="modal"
              aria-label="Close"/>
          </div>
          <div
            class="modal-body"
            dir="rtl">
            <p>
              هورا قابلیت تشخصی ۳۹ یوگا را دارد شما می‌توانید با فعال کردن گزینه <b>شناسایی چارت</b> این قابلیت را در
              محاسبه چارت فعال کنید.
            </p>
            <div>
              لیست یوگاهای قابل تشخیص:
              <ol
                class="list-group list-group-numbered"
                dir="ltr">

                <li>Adhi</li>
                <li>Chandra Mangala</li>
                <li>Sunapha</li>
                <li>Chatussagara</li>
                <li>Vasumathi</li>
                <li>Gajakesari</li>
                <li>Rajalakshana</li>
                <li>Anapha</li>
                <li>Dhurdhura</li>
                <li>Kemadruma</li>
                <li>Amala</li>
                <li>Bheri</li>
                <li>Sankha</li>
                <li>Budha Aditya</li>
                <li>Bhadra</li>
                <li>Ruchaka</li>
                <li>Sasa</li>
                <li>Obhayachari</li>
                <li>Vesi</li>
                <li>Vasi</li>
                <li>Parvata</li>
                <li>Devendra</li>
                <li>Gandharva</li>
                <li>Parivartana</li>
                <li>Rajju</li>
                <li>Musala</li>
                <li>Nala</li>
                <li>Sarpa</li>
                <li>Srik</li>
                <li>Kamala</li>
                <li>Vapee</li>
                <li>Samadura</li>
                <li>Vallaki</li>
                <li>Damni</li>
                <li>Pasa</li>
                <li>Kedara</li>
                <li>Gola</li>
                <li>Sula</li>
                <li>Yuga</li>
              </ol>
            </div>
          </div>
          <div
            class="modal-footer"
            dir="rtl">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-bs-dismiss="modal">بستن</button>
              <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
    <div
      id="aboutHoraPro"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="aboutHoraPro"
      aria-hidden="true"
      style="background: rgba(0, 0, 0, 0.2)">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div
            class="modal-header"
            dir="rtl">
            <h1
              id="exampleModalLabel"
              class="modal-title fs-5">یادداشت انتشار</h1>
            <button
              type="button"
              class="btn-close me-auto ms-0"
              data-bs-dismiss="modal"
              aria-label="Close"/>
          </div>
          <div
            class="modal-body"
            dir="rtl">
            <p>
              هورا پرو نسخه ۱.۰.۵
            </p>
            <div>
              امکانات:
              <ul>
                <li>
                  محاسبه چارت جیوتیش بر اساس آیانامشا لاهیری
                </li>
                <li>
                  امکان محاسبه پرشنا
                </li>
                <li>
                  امکان دریافت چارت در وارگا‌های متفاوت
                  <div>
                    <span class="badge bg-light text-dark border border-dark">Hora</span>
                    <span class="badge bg-light text-dark border border-dark">Drekkana</span>
                    <span class="badge bg-light text-dark border border-dark">Chaturthamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Saptamamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Navamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Dashamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Dvadashamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Shodashamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Vimshamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Chaturvimshamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Saptavimshamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Trimshamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Khavedamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Akshavedamsha</span>
                    <span class="badge bg-light text-dark border border-dark">Shashtiamsha</span>
                  </div>
                </li>
                <li>
                  امکان دریافت ترانزیت چارت
                </li>
                <li>
                  جدول سیاره‌ای پیشرفته از جمله محاسبه روابط سیاره‌ای، آشتا، کاراکا‌ها و ...
                </li>
                <li>
                  استفاده از کاملترین اطلس متن باز (OpenStreetMap)
                </li>
                <li>
                  امکان محاسبه اتوماتیک منطقه‌زمانی
                </li>
                <li>
                  ذخیره نامحدود چارت تولد
                </li>
                <li>
                  امکان دریافت خروجی چارت به صورت PDF
                </li>
                <li>
                  به اشتراک گذاری چارت
                </li>
                <li>
                  تشخیص اتصالات چارت
                </li>
                <li>
                  تشخیص نظرات سیارات
                </li>
                <li>
                  امکان یادداشت‌برداری بر روی چارت
                </li>
                <li>
                  تشخیص ۳۹ یوگا
                  لیست یوگاهای قابل تشخیص:

                  <div>
                    <span class="badge bg-light text-dark border border-dark"> Adhi </span>
                    <span class="badge bg-light text-dark border border-dark"> Chandra </span>
                    <span class="badge bg-light text-dark border border-dark"> Sunapha </span>
                    <span class="badge bg-light text-dark border border-dark"> Chatussagara </span>
                    <span class="badge bg-light text-dark border border-dark"> Vasumathi </span>
                    <span class="badge bg-light text-dark border border-dark"> Gajakesari </span>
                    <span class="badge bg-light text-dark border border-dark"> Rajalakshana </span>
                    <span class="badge bg-light text-dark border border-dark"> Anapha </span>
                    <span class="badge bg-light text-dark border border-dark"> Dhurdhura </span>
                    <span class="badge bg-light text-dark border border-dark"> Kemadruma </span>
                    <span class="badge bg-light text-dark border border-dark"> Amala </span>
                    <span class="badge bg-light text-dark border border-dark"> Bheri </span>
                    <span class="badge bg-light text-dark border border-dark"> Sankha </span>
                    <span class="badge bg-light text-dark border border-dark"> Budha </span>
                    <span class="badge bg-light text-dark border border-dark"> Bhadra </span>
                    <span class="badge bg-light text-dark border border-dark"> Ruchaka </span>
                    <span class="badge bg-light text-dark border border-dark"> Sasa </span>
                    <span class="badge bg-light text-dark border border-dark"> Obhayachari </span>
                    <span class="badge bg-light text-dark border border-dark"> Vesi </span>
                    <span class="badge bg-light text-dark border border-dark"> Vasi </span>
                    <span class="badge bg-light text-dark border border-dark"> Parvata </span>
                    <span class="badge bg-light text-dark border border-dark"> Devendra </span>
                    <span class="badge bg-light text-dark border border-dark"> Gandharva </span>
                    <span class="badge bg-light text-dark border border-dark"> Parivartana </span>
                    <span class="badge bg-light text-dark border border-dark"> Rajju </span>
                    <span class="badge bg-light text-dark border border-dark"> Musala </span>
                    <span class="badge bg-light text-dark border border-dark"> Nala </span>
                    <span class="badge bg-light text-dark border border-dark"> Sarpa </span>
                    <span class="badge bg-light text-dark border border-dark"> Srik </span>
                    <span class="badge bg-light text-dark border border-dark"> Kamala </span>
                    <span class="badge bg-light text-dark border border-dark"> Vapee </span>
                    <span class="badge bg-light text-dark border border-dark"> Samadura </span>
                    <span class="badge bg-light text-dark border border-dark"> Vallaki </span>
                    <span class="badge bg-light text-dark border border-dark"> Damni </span>
                    <span class="badge bg-light text-dark border border-dark"> Pasa </span>
                    <span class="badge bg-light text-dark border border-dark"> Kedara </span>
                    <span class="badge bg-light text-dark border border-dark"> Gola </span>
                    <span class="badge bg-light text-dark border border-dark"> Sula </span>
                    <span class="badge bg-light text-dark border border-dark"> Yuga </span>
                  </div>

                </li>
              </ul>
            </div>
          </div>
          <div
            class="modal-footer"
            dir="rtl">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-bs-dismiss="modal">بستن</button>
              <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HoraLogo from '../components/HoraLogo.vue'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import HelperLib from '../components/helper'
import ApiService from '../service/api'
import Loading from '../components/Loading.vue'

export default {
  name: 'SettingsView',
  components: {
    Loading,
    HoraLogo,
    Autocomplete,
    HelperLib
  },
  data () {
    return {
      show_yogas: false,
      show_analysis: true,
      success: false,
      error: false,
      isLoading: false,
      longitude: '51.3896004',
      latitude: '35.6892523',
      country: 'Iran',
      city: 'Tehran',
      state: 'Tehran Province',
      selectedLocation: 'Iran - Tehran Province - Tehran',
      colors: {
        زرد: '#FFFDE7',
        آبی: '#E8FFFE',
        سفید: '#FFFFFF',
        سبز: '#E8FFEA',
        نارنجی: '#FFF7E8'
      },
      selectedColor: '#FFFDE7',
      enable_submit: false
    }
  },
  created () {
    this.populateSettings()
  },
  methods: {
    populateSettings () {
      this.isLoading = true
      ApiService.getSettings().then((response) => {
        if (response['data']['status'] == 1) {
          this.longitude = response['data']['settings']['longitude']
          this.latitude = response['data']['settings']['latitude']
          this.country = response['data']['settings']['country']
          this.city = response['data']['settings']['city']
          this.state = response['data']['settings']['state']
          this.selectedColor = response['data']['settings']['chart_bg']
          this.show_analysis = response['data']['settings']['show_analysis'] == '1' ? 1 : 0
          this.show_yogas = response['data']['settings']['show_yogas'] == '1' ? 1 : 0
          this.selectedLocation = `${this.country} - ${this.state} - ${this.city}`
        }
        this.isLoading = false
      })
    },
    updateSettings () {
      const request = {
        longitude: this.longitude,
        latitude: this.latitude,
        country: this.country,
        city: this.city,
        state: this.state,
        color: this.selectedColor,
        show_yogas: this.show_yogas ? 1 : 0,
        show_analysis: this.show_analysis ? 1 : 0
      }
      this.isLoading = true
      ApiService.updateSettings(request).then((response) => {
        this.isLoading = false
        if (response['data']['status'] == 1) {
          // console.log(response)
          this.longitude = response['data']['longitude']
          this.latitude = response['data']['latitude']
          this.country = response['data']['country']
          this.city = response['data']['city']
          this.state = response['data']['state']
          this.color = response['data']['color']
          this.show_analysis = response['data']['show_analysis']
          this.show_yogas = response['data']['show_yogas']
          // localStorage.setItem("hora_show_analysis", this.show_analysis);
          // localStorage.setItem("hora_show_yogas", this.show_yogas);
          this.error = false
          this.success = true
          setTimeout(() => {
            this.success = false
          }, 2000)
          this.enable_submit = false
        } else {
          this.error = true
          this.success = false
          setTimeout(() => {
            this.error = false
          }, 2000)
        }
      })
    },
    selectColor (color) {
      this.selectedColor = color
      // console.log(color);
    },
    search (input) {
      return new Promise((resolve) => {
        // const url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(
        //   input,
        // )}`
        // let url = `https://photon.komoot.io/api/?q=${encodeURI(input)}&layer=city`;
        let url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(input)}`

        if (input.length < 3) {
          return resolve([])
        }
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            resolve(data.features)
          })
      })
    },
    getResultValue (result) {
      let _c = result['properties']['address']['country']
        ? result['properties']['address']['country']
        : 'بدون کشور'
      let _m = result['properties']['address']['state']
        ? result['properties']['address']['state']
        : result['properties']['address']['province']
          ? result['properties']['address']['province']
          : result['properties']['address']['region'] ? result['properties']['address']['region'] : ''
      let _ci = result['properties']['address']['city']
        ? result['properties']['address']['city']
        : result['properties']['address']['village']
          ? result['properties']['address']['village']
          : result['properties']['address']['hamlet'] ? result['properties']['address']['hamlet'] : ''
      let _vi = result['properties']['address']['town']
        ? result['properties']['address']['town']
        : ''
      return result['properties']['name'] + ' - ' + _m + ' - ' + _c

      // return _c + " , " + _m + " , " + _ci + _vi;
    },
    handleSubmit (result) {
      // console.log(result);
      this.longitude = result['geometry']['coordinates'][0]
      this.latitude = result['geometry']['coordinates'][1]
      // const lon_dms = HelperLib.convertDegreeToDMS(this.longitude, true);
      // const lat_dms = HelperLib.convertDegreeToDMS(this.latitude);

      // result["properties"]["countrycode"]
      const name = result['properties']['address']['city']
        ? result['properties']['address']['name']
        : 'بدون شهر'
      const state = result['properties']['address']['province']
        ? result['properties']['address']['state']
        : 'بدون استان'
      const country = result['properties']['address']['country']
        ? result['properties']['address']['country']
        : 'بدون کشور'

      this.city = name
      this.state = state
      this.country = country
      this.selectedLocation = `${country} - ${state} - ${name}`
      if ('properties' in result) {
        this.enable_submit = true
      }
    }
  }
}
</script>

<style scoped>
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>

<style scoped>
.color-input {
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 12px 12px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: right;
  margin: 0;
}

.settings-input {
  border: 1px solid #ced4da;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  text-align: center;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: right;
  margin: 0;
}

.color-preview {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}

/* The switch - the box around the slider */
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 62px;
  height: 35px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 1;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  background: #fff;
  transition: .4s;
  border-radius: 30px;
  border: 1px solid #ccc;
}

.slider:before {
  position: absolute;
  content: "";
  height: 1.9em;
  width: 1.9em;
  border-radius: 16px;
  left: 1.2px;
  top: 0;
  bottom: 0;
  background-color: white;
  box-shadow: 0 2px 5px #999999;
  transition: .4s;
}

input:checked+.slider {
  background-color: #0d6efd;
  border: 1px solid transparent;
}

input:checked+.slider:before {
  transform: translateX(1.5em);
}
</style>
